import React from "react";
import Navbar from "../components/Navbar.js";
import Hero from "../components/pp/Hero.js";
import Sect1 from "../components/pp/Sect1.js";
import Sect2 from "../components/pp/Sect2.js";
import Sect3 from "../components/pp/Sect3.js";
import ParentReview from "../components/pp/ParentReview.js";
import FAQs from "../components/FAQs.js";
import Aside from "../components/AsideSection.js";
import Footer from "../components/Footer.js";

const ParentPage = () => {
  return (
    <div>
      <Navbar />
      <header>
        <Hero />
      </header>
      <main>
        <Sect1 />
        <Sect2 />
        <Sect3 />
        <ParentReview />
        <FAQs />
      </main>

      <aside>
        <Aside />
      </aside>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default ParentPage;
